import { orchestrator } from 'satcheljs';
import { navigateToReportByName, onChangeReportId } from '../actions';
import { getPageStore } from '../store/store';

orchestrator(navigateToReportByName, ({ reportName, history }) => {
  const reports = getPageStore().reports;
  const reportId = reports
    .find((section) => section.items.some((item) => item.name === reportName))
    ?.items.find((item) => item.name === reportName)?.id;
  if (reportId !== undefined) {
    onChangeReportId(reportId, history);
  }
});
